// extracted by mini-css-extract-plugin
module.exports = {"eventPageWrapper":"eventPage_eventPageWrapper__uMJ8_"};